import React, { useRef } from "react";
import "./../styles/Projects.css";
import cryptoImg from "../assets/topcoin.png";
import weddingImg from "../assets/selva-mahal.png";
import mobileImg from "../assets/tcuk_mobile.png";
import adminImg from "../assets/topcoin_admin.png";
import copImg from "../assets/cop_web.png";
import autoImg from "../assets/auto_guard.png";
import driveImg from "../assets/uk_drive.png";
import bakeryImg from "../assets/bakery.png";
import revyvImg from "../assets/revyv_care.png";

export default function Projects() {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollRef.current;
    const card = container.querySelector(".project-card");
    const scrollAmount = card.offsetWidth + 20;

    if (direction === "left") {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const projects = [
    {
      title: "TopCoin UK Website",
      description:
        "Convert loyalty points into cash with secure wallet integration.",
      image: cryptoImg,
      tags: ["React", "Blockchain", "Wallet"],
      link: "https://topcoinuk.com/",
    },
    {
      title: "TopCoin UK Corporate Website",
      description:
        "A Web Application for convert loyalty points into cash with secure wallet integration.",
      image: copImg,
      tags: ["UI/UX", "Website", "Figma"],
      link: "https://www.figma.com/design/eAbgWG8h4XoCsgFQ99tk0U/TCUK_Corporate_website?node-id=0-1&p=f&t=VpdxaG6u3iXoD6su-0",
    },
    {
      title: "TopCoin UK Mobile App",
      description:
        "A Mobile Application for convert loyalty points into cash with secure wallet integration.",
      image: mobileImg,
      tags: ["UI/UX", "Mobile App", "Figma"],
      link: "https://www.figma.com/design/dALKQIyv68Xtskf71Kvg1y/TC-Mobile-App?node-id=0-1&p=f&t=LrliC697P5dno5jx-0",
    },
    {
      title: "TopCoin UK Admin Panel",
      description:
        "An Admin panel for manage and control various types of member accounts.",
      image: adminImg,
      tags: ["UI/UX", "Admin", "Figma"],
      link: "https://www.figma.com/design/9RPSPi4aLwjAJtpDUNK2mx/TCUK_Super-admin?node-id=0-1&p=f&t=zOO9teWyJYk9Lw8V-0",
    },
    {
      title: "Wedding Hall Booking Website",
      description:
        "Modern booking platform with search filtering and secure payments.",
      image: weddingImg,
      tags: ["Figma", "UI/UX", "Prototype"],
      link: "https://www.figma.com/design/U2AzfdzdVn1DG9HTejiOf7/",
    },
    {
      title: "Auto Guard App",
      description:
        "Locate nearby services instantly when vehicle breaks down.",
      image: autoImg,
      tags: ["Figma", "Mobile UI", "UX"],
      link: "https://www.figma.com/design/6iudwDv9uaCGHptNIEPii9/",
    },
    {
      title: "UK Drive App",
      description:
        "Interactive driving learning game with engaging UX design.",
      image: driveImg,
      tags: ["Figma", "Prototype", "User Flow"],
      link: "https://www.figma.com/design/WhDHnPLaRVsUkTbtmxYTNI/",
    },
    {
      title: "King Vita Website",
      description:
        "Authentic french bakery products showcase website.",
      image: bakeryImg,
      tags: ["Figma", "Prototype", "UI Design"],
      link: "https://www.figma.com/design/fDPcN2kVy5KWAaU4ZyX3ej/",
    },
    {
      title: "Revyv Care Website",
      description:
        "A future ready Student development platform.",
      image: revyvImg,
      tags: ["Counselling", "Digital Marketing", "Student"],
      link: "https://revyvcare.com/",
    },
  ];

  return (
    <section id="projects" className="projects">
      <div className="projects-inner">
        <h2 className="section-head">Projects</h2>
        <p className="section-sub">
          Selected work with live links and real-world applications.
        </p>

      
        <div className="projects-slider-wrapper">
          <button className="scroll-btn left" onClick={() => scroll("left")}>
            ❮
          </button>

          <div className="projects-slider" ref={scrollRef}>
            {projects.map((project, index) => (
              <div key={index} className="project-card">
                <div className="image-container">
                  <img src={project.image} alt={project.title} />
                </div>

                <div className="project-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>

                  <div className="project-tags">
                    {project.tags.map((tag, i) => (
                      <span key={i} className="tag">
                        {tag}
                      </span>
                    ))}
                  </div>

                  <a
                    href={project.link}
                    className="project-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Project
                  </a>
                </div>
              </div>
            ))}
          </div>

          <button className="scroll-btn right" onClick={() => scroll("right")}>
            ❯
          </button>
        </div>


        <div className="clients-feedback">
          <h3>Clients Feedback</h3>

          <div className="feedback-grid">
            <div className="feedback-card">
              <p>
                “Working with you was an absolute pleasure! The project exceeded expectations.”
              </p>
              <h4>- Client Era Ela</h4>
            </div>

            <div className="feedback-card">
              <p>
                “Professional and timely delivery. Highly recommended.”
              </p>
              <h4>- Client Siva</h4>
            </div>
          </div>
        </div>

        <div className="project-contact">
          <h3>Interested in Collaborating?</h3>
          <p>
            Let's create something amazing together. Reach out for project discussions.
          </p>
          <a href="#contact" className="contact-btn">
            Contact Me
          </a>
        </div>
      </div>
    </section>
  );
}